import { render, staticRenderFns } from "./AdvPlaMng.vue?vue&type=template&id=65f2564c&scoped=true&"
import script from "./AdvPlaMng.vue?vue&type=script&lang=js&"
export * from "./AdvPlaMng.vue?vue&type=script&lang=js&"
import style0 from "./AdvPlaMng.vue?vue&type=style&index=0&id=65f2564c&lang=css&scoped=true&"
import style1 from "./AdvPlaMng.vue?vue&type=style&index=1&id=65f2564c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f2564c",
  null
  
)

export default component.exports